import Logo from "../Logo/Logo";
import TprIcon from "../TprIcon/TprIcon";

const Footer = () => {
  const today = new Date();

  return (
    <div>
      <footer className="w-full tpr-background text-white text-center text-sm p-8">
        <div className="flex flex-row justify-center mb-4">
          <TprIcon size="medium" />
        </div>
        <div className="flex flex-row justify-center mb-4">
          <Logo color="white" size="medium" />
        </div>
        <div className="w-2/3 mx-auto mb-4">
          &copy; {today.getFullYear()} The Practice Rooms Ltd. Registered in England & Wales. Registered number:
          7311013. Registered Address: Suite 8, Westbury Court, Church Road, Bristol, BS9 3EF.
        </div>
      </footer>
      <div className="w-full bg-indigo-900 text-xs text-white px-8 p-4">
        Your access to this system as a Member is governed by our{" "}
        <a href="/terms/acceptable-use-policy" className="underline">
          Acceptable Use Policy
        </a>
        . Your data is handled in accordance with our{" "}
        <a href="/terms/privacy-policy" className="underline">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="/terms/cookies-policy" className="underline">
          Cookies &amp; Similar Technologies Policy
        </a>
        .
      </div>
    </div>
  );
};

export default Footer;
